// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"Spinner_spinWrapper__BhvCc","spinner":"Spinner_spinner__PO4cy","spin":"Spinner_spin__rTJSV"};